import type { SVGProps } from 'react'
const SvgSyArchiveFill = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" width={24} height={24} {...props}>
		<path
			fillOpacity={0.2}
			d="M133.3 310c0-4.7 0-7.1 1.5-8.5 1.5-1.5 3.8-1.5 8.5-1.5h513.3c4.7 0 7.1 0 8.5 1.5 1.5 1.5 1.5 3.8 1.5 8.5v190c0 62.9 0 94.3-19.5 113.8s-51 19.5-113.8 19.5H266.6c-62.9 0-94.3 0-113.8-19.5s-19.5-51-19.5-113.8zm-66.6-76.7c0-36.8 29.8-66.7 66.7-66.7h533.3c36.8 0 66.7 29.8 66.7 66.7s-14.9 33.3-33.3 33.3H100c-18.4 0-33.3-14.9-33.3-33.3"
		/>
		<path d="M316.7 400h166.7c9.2 0 16.7 7.5 16.7 16.7s-7.5 16.7-16.7 16.7H316.7c-9.2 0-16.7-7.5-16.7-16.7s7.5-16.7 16.7-16.7" />
	</svg>
)
export default SvgSyArchiveFill
